<mat-form-field subscriptSizing="dynamic">
    <mat-label>{{ label() }}</mat-label>
    <mat-date-range-input
        [formGroup]="range"
        [disabled]="disabled()"
        [rangePicker]="picker">
        <input
            matStartDate
            formControlName="from"
            [placeholder]="startDateLabel()"
            (keyup.enter)="onEnter()" />
        <input
            matEndDate
            formControlName="to"
            [placeholder]="endDateLabel()"
            (keyup.enter)="onEnter()" />
    </mat-date-range-input>
    <mat-datepicker-toggle
        matIconSuffix
        [for]="picker" />
    <mat-hint>{{ dateRange() }}</mat-hint>

    <mat-date-range-picker
        #picker
        (closed)="onClosed()">
        <mat-date-range-picker-actions>
            <mat-selection-list
                st-click-stop-propagation
                hideSingleSelectionIndicator
                class="st-date-range-picker-periods"
                multiple="false"
                [ngModel]="selectedPeriod()"
                (selectionChange)="onSelectionChange($event)">
                @for (p of periods(); track p) {
                    <mat-list-option [value]="p.id">
                        {{ p.label }}
                    </mat-list-option>
                }
            </mat-selection-list>
            <div class="st-date-range-picker-action-buttons">
                <button
                    mat-button
                    matDatepickerCancel>
                    {{ cancelButtonLabel() }}
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    matDatepickerApply
                    (click)="onApply()">
                    {{ applyButtonLabel() }}
                </button>
            </div>
        </mat-date-range-picker-actions>
    </mat-date-range-picker>
</mat-form-field>
